import React from "react";
import { useAuthToken } from "../auth/useAuthToken";
import { useStockSearch } from "./useStockSearch";
import SearchFilters from "./SearchFilters";
import HeaderSearch from "../../components/header/HeaderSearch";
import Loader from "../../components/Loader";
import RenderSearchResults from "../../components/RenderSearchResults";
import FooterSticky from "../../components/FooterSticky";
import "../../css/search.css";
import "../../css/index.css";

export default function SearchPage() {
  const { token, tenant, error: authError, loading: authLoading } =
    useAuthToken();

  const {
    query,
    results,
    message,
    loading: stockLoading,
    fileDate,
    scannerResult,
    handleInputChange,
    onScanBarcode,
    availableStatuses,
    selectedStatuses,
    toggleStatus,
    abandonedCount,
    showAbandoned,
    toggleAbandoned,
  } = useStockSearch({ token, tenant, authError });

  const showLoader = authLoading || stockLoading;
  const activeQuery = (scannerResult || query).trim();
  const showEmptyHint = !showLoader && !activeQuery && !message;
  const showFilters =
    !showLoader && Boolean(activeQuery) && (availableStatuses.length > 0 || abandonedCount > 0);

  return (
    <div className="header-container">
      <HeaderSearch
        query={query}
        handleInputChange={handleInputChange}
        scannerResult={scannerResult}
        onScanBarcode={onScanBarcode}
      />
      <div className="container">
        {showLoader ? (
          <Loader loading />
        ) : (
          <>
            {message && (
              <p className="products-number" role="status" aria-live="polite">
                {message}
              </p>
            )}
            {showFilters && (
              <SearchFilters
                availableStatuses={availableStatuses}
                selectedStatuses={selectedStatuses}
                onToggleStatus={toggleStatus}
                abandonedCount={abandonedCount}
                showAbandoned={showAbandoned}
                onToggleAbandoned={toggleAbandoned}
              />
            )}
            {showEmptyHint && (
              <div className="search-empty">
                <h2 className="search-empty-title">Rechercher</h2>
                <p className="search-empty-text">
                  Saisissez une référence, un Gencod ou un SKU client pour
                  afficher la disponibilité.
                </p>
              </div>
            )}
            <RenderSearchResults results={results} />
          </>
        )}
      </div>
      <FooterSticky date={fileDate} />
    </div>
  );
}
